var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t("contract.other_absence.headline")))])]),_c('p',[_vm._v(_vm._s(_vm.$t('contract.other_absence.paragraphs.first')))]),_c('hr')])
}
var staticRenderFns = []

export { render, staticRenderFns }